<template>
  <div class="Child">
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-button type="primary" @click="designcar()">查询</el-button>
        <el-button type="primary" @click="funcAdd">新增</el-button>
        <el-button type="primary" @click="getSelectEvent">确定</el-button>
      </template>
    </vxe-toolbar>

    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      height="450"
      :loading="loading"
      :checkbox-config="{ highlight: true }"
      :data="tableData"
      auto-resize
    >
      <vxe-table-column type="checkbox" width="60" />
      <vxe-table-column>
        <vxe-table-column field="name" title="分组名称" min-width="130" />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="280"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="130" fixed="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="funcEdit(scope.row)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="1000"
      height="600"
      resize
    >
      <!-- modelAddFlag 解决宽度异常问题 -->
      <compAdd
        v-if="modelAddFlag"
        :shipment-party-code="shipmentPartyCode"
        :restaurants="restaurants"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="1000"
      height="600"
      resize
    >
      <compEdit
        ref="editRef"
        :shipment-party-code="shipmentPartyCode"
        :restaurants="restaurants"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
  </div>
</template>

<script>
import { vehicleTeam } from "@/api/orderform";
import compAdd from "@/views/basicInfo/shipment/shipmentForm/components/vehicleTeam/components/vehicleTeamAdd";
import compEdit from "@/views/basicInfo/shipment/shipmentForm/components/vehicleTeam/components/vehicleTeamEdit";
import { driverListForShipTeam, delVehicleTeam } from "@/api/shipment";
export default {
  name: "Child",
  components: {
    compAdd,
    compEdit
  },
  props: {
    shipmentPartyCode: {
      type: String,
      default: ""
    },
    branchCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      modelAddFlag: false,
      modelEditFlag: false,
      tableData: [],
      restaurants: [],
      listQuery: {
        gmtCreatedRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        acceptType: "1",
        userCode: "",
        name: "",
        gmtCreated: ""
      },
      Pagingconf: [],
      selectRecords: [],
      options: [
        {
          value: "0",
          label: "空载"
        },
        {
          value: "1",
          label: "负载"
        }
      ]
    };
  },
  watch: {
    branchCode() {
      this.getDriverListForShipTeam();
    }
  },
  created() {
    this.designcar();
    this.getDriverListForShipTeam();
  },
  methods: {
    closeData() {
      this.listQuery = {
        gmtCreatedRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        acceptType: "1",
        userCode: "",
        name: "",
        gmtCreated: ""
      };
    },

    getDriverListForShipTeam() {
      //查询独立实际承运人+车队，不包含车队的实际承运人
      driverListForShipTeam({
        pageSize: 100000,
        driverType: 3,
        authStatus: 3,
        isFreeze: 0,
        branchCodeExt: this.branchCode
      }).then(response => {
        this.restaurants = response.data.records;
      });
    },
    designcar() {
      if (this.shipmentPartyCode) {
        this.listQuery.userCode = this.shipmentPartyCode;
      } else {
        this.listQuery.userCode = this.$store.getters.party.code;
      }
      this.loading = true;
      vehicleTeam(this.listQuery).then(response => {
        this.loading = false;
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        this.Pagingconf = [20, 30, 50, 100, response.data.total];
      });
    },
    // 新增
    funcAdd() {
      this.modelAddFlag = true;
    },
    // 编辑
    funcEdit(row) {
      this.modelEditFlag = true;
      this.$refs.editRef.getInfo(row.name, row.code);
    },
    // 删除方法
    funcDelete(codes) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          delVehicleTeam({ teamCodes: codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.designcar();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.designcar();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.designcar();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
      }
    },
    getSelectEvent() {
      let selectRecords = this.$refs.xTable.getCheckboxRecords();
      if (selectRecords.length > 0) {
        this.$emit("event", selectRecords, 1);
      } else {
        this.$message({ message: "请至少选择一个承运分组", type: "warning" });
      }
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.designcar();
    }
  }
};
</script>

<style></style>
